import { render, staticRenderFns } from "./addDictInfo.vue?vue&type=template&id=4eec6756&scoped=true"
import script from "./addDictInfo.vue?vue&type=script&lang=js"
export * from "./addDictInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eec6756",
  null
  
)

export default component.exports